// in constructor sync storage

export class AsyncStorage /*implements IAsyncStorage*/ {
    // TODO: Implement
}
